// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mobile-cards-container[data-v-f74f7b8e]{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    row-gap: 15px;\r\n    -moz-column-gap: 15px;\r\n         column-gap: 15px;\r\n    margin-bottom: 15px;\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
